






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import LabelOperation from '@/components/label/labelOperation.vue';
import CommentList from '@/components/comment/commentList.vue';
import ModuleTemplateTodo from './moduleTemplateTodo.vue';
import { createCommentUrl } from '@/components/comment/commentOperation';
import DetailBox from '@/components/detailBox/detailBox.vue';
import { timeFormat } from '@/utils/other';
import { AccountModule } from '@/store/modules/account';

type IModuleTemplateInfo = IModule.IResponse.IModuleTemplateInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;


@Component({
  components: {
    LabelOperation,
    CommentList,
    ModuleTemplateTodo,
    DetailBox,
  },
})
export default class ModuleTemplateDetail extends Vue {
  @Prop({required: true}) private template!: IModuleTemplateInfo;
  get templateId(): string {
    if (this.template) {
      return this.template.id;
    } else {
      return '';
    }
  }
  get accountName(): string {
    return AccountModule.userDetailInfo!.name;
  }
  get templateCreateBy(): string {
    return this.template.templateCreateBy;
  }
  get canEdit() {
    if (this.template) {
      return (!['Cancel'].includes(this.template.status));
    }
    return false;
  }
  get commentUrl() {
    return createCommentUrl('Module', this.templateId);
  }
  get createdOn() {
    if (this.template) {
      return timeFormat(this.template.createdOn);
    } else {
      return '';
    }
  }
  private handleUpdateStatus(status: IModule.IModuleStatus) {
    let operation = '';
    switch (status) {
      case 'Completed':
        operation = this.$t('form.complete').toString();
        break;
      case 'Closed':
        operation = this.$t('form.close').toString();
        break;
      case 'Cancel':
        operation = this.$t('form.cancel').toString();
        break;
      default:
        break;
    }
    this.$confirm({
      title: this.$t('operation.confirmMsg', {
        operation,
      }).toString(),
      onOk: () => {
        this.cancelTemplate();
      },
    });
  }
  private cancelTemplate() {
    this.$emit('statusChange', {
      module: this.template,
    });
  }
  private handleRemove() {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {
        operation: this.$t('form.delete'),
      }).toString(),
      onOk: () => {
        this.removeTemplate();
      },
    });
  }
  private editTemplate() {
    this.$emit('edit', this.template);
  }
  private removeTemplate() {
    this.$emit('delete', this.template.id);
  }
  private handleCommentAdd(newComment: ICreateOrUpdateComment) {
    this.$emit('commentChange', {
      template: this.template,
      comment: newComment,
      type: 'ADD',
    });
  }
}
